import ImageCropper from './image-cropper'

export type { ImageCropperProps } from './image-cropper'

export default ImageCropper
